import { sanitizeHTML } from "@/lib/utils";

interface DirectusBreadcrumbsData {
  title?: string;
  links?: {
    menu_items_id: {
      href: string;
      label: string;
    };
  }[];
}

export const fields = [
  "title",
  "links.menu_items_id.href",
  "links.menu_items_id.label",
] as const;

interface BreadcrumbsProps {
  data?: DirectusBreadcrumbsData;
}

export default function Breadcrumbs({ data }: BreadcrumbsProps) {
  // Default values or early return if no data
  if (!data) return null;

  return (
    <nav className="w-full bg-white" aria-label="Breadcrumb">
      {/* Breadcrumbs */}
      <div className="max-w-screen-2xl mx-auto px-8 py-8">
        <div className="text-primary text-sm font-greycliff">
          {data.links?.map((link, index) => {
            const isLast = index === (data.links?.length ?? 0) - 1;
            return (
              <span key={index}>
                {index > 0 && " / "}
                {isLast ? (
                  <span>{link.menu_items_id.label}</span>
                ) : (
                  <a href={link.menu_items_id.href} className="hover:underline">
                    {link.menu_items_id.label}
                  </a>
                )}
              </span>
            );
          })}
        </div>
      </div>
    </nav>
  );
} 
